import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function OpenAiIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M14.949 6.54743C15.1304 6.00869 15.1931 5.43797 15.133 4.87341C15.0729 4.30884 14.8914 3.76342 14.6005
          3.27359C13.7157 1.7545 11.9375 0.973043 10.2009 1.34016C9.71999 0.812536 9.10684 0.419014 8.42299 0.199114C7.73914
          -0.0207862 7.00867 -0.059322 6.30495 0.0873766C5.60122 0.234075 4.94901 0.560844 4.41383 1.03486C3.87865 1.50888
          3.47933 2.11346 3.25598 2.78789C2.6921 2.90196 2.15939 3.13344 1.69346 3.46687C1.22753 3.80029 0.839118 4.22797
          0.554174 4.72132C-0.340225 6.23795 -0.137206 8.15113 1.05616 9.45226C0.874129 9.99075 0.81078 10.5614 0.870346
          11.126C0.929913 11.6906 1.11102 12.2361 1.40156 12.7261C2.28732 14.2458 4.06672 15.0271 5.80438 14.6595C6.18643
          15.0839 6.65587 15.423 7.18134 15.6541C7.70682 15.8852 8.27624 16.0031 8.85159 15.9999C10.6316 16.0015 12.2087
          14.868 12.7523 13.1961C13.3161 13.0818 13.8488 12.8503 14.3147 12.5169C14.7806 12.1835 15.169 11.7559 15.4541
          11.2627C16.3378 9.74867 16.1339 7.84581 14.949 6.54743ZM8.8515 14.9528C8.14099 14.9539 7.45275 14.7083 6.90746
          14.259L7.0034 14.2053L10.2328 12.3666C10.3132 12.3201 10.3799 12.2537 10.4264 12.1741C10.473 12.0945 10.4977
          12.0043 10.4982 11.9124V7.42106L11.8635 8.20015C11.8702 8.20353 11.8761 8.20843 11.8805 8.21444C11.885 8.22046
          11.8879 8.22743 11.8891 8.23479V11.9566C11.8856 13.61 10.5277 14.9494 8.8515 14.9529V14.9528ZM2.32234
          12.2025C1.96603 11.5956 1.83809 10.8842 1.96102 10.1935L2.05696 10.2503L5.28954 12.089C5.36953 12.1353 5.46059
          12.1597 5.55334 12.1597C5.64609 12.1597 5.73715 12.1353 5.81714 12.089L9.76595 9.84341V11.3984C9.76557 11.4064
          9.76336 11.4142 9.75949 11.4213C9.75562 11.4284 9.75019 11.4345 9.74359 11.4393L6.47264 13.3002C5.01907 14.1261
          3.16205 13.635 2.32234 12.2025ZM1.47179 5.2639C1.83059 4.65306 2.39692 4.18716 3.07052 3.94867V7.73338C3.06931
          7.82483 3.093 7.91493 3.13912 7.99427C3.18524 8.07361 3.25211 8.13929 3.33274 8.18444L7.26236 10.4206L5.89706
          11.1997C5.88968 11.2036 5.88144 11.2056 5.87308 11.2056C5.86471 11.2056 5.85648 11.2036 5.84909 11.1997L2.58456
          9.34191C1.13387 8.51256 0.636399 6.6821 1.47179 5.24809V5.2639ZM12.6884 7.83436L8.74605 5.57612L10.1081
          4.80025C10.1155 4.79638 10.1237 4.79436 10.1321 4.79436C10.1404 4.79436 10.1487 4.79638 10.1561 4.80025L13.4207
          6.66109C13.9198 6.94522 14.3267 7.36353 14.5938 7.8672C14.861 8.37087 14.9774 8.9391 14.9294 9.50557C14.8815
          10.072 14.6712 10.6134 14.3231 11.0664C13.975 11.5194 13.5034 11.8653 12.9634 12.0639V8.27899C12.9606 8.1877
          12.9338 8.09871 12.8856 8.02075C12.8374 7.94278 12.7694 7.87861 12.6884 7.83436ZM14.0473 5.81897L13.9514
          5.76219L10.7252 3.90769C10.6447 3.86111 10.5531 3.83655 10.4598 3.83655C10.3665 3.83655 10.2749 3.86111
          10.1944 3.90769L6.2488 6.15315V4.59819C6.24798 4.5903 6.24934 4.58235 6.25271 4.57516C6.25609 4.56796
          6.26136 4.5618 6.26799 4.55731L9.53251 2.69949C10.0329 2.41517 10.6049 2.27725 11.1818 2.30187C11.7587 2.32649
          12.3166 2.51263 12.7902 2.83852C13.2638 3.16441 13.6335 3.61658 13.8561 4.14214C14.0787 4.6677 14.145 5.24492
          14.0473 5.80629V5.81897ZM5.50378 8.5755L4.13849 7.79963C4.13166 7.79556 4.12583 7.79005 4.12141 7.78351C4.11698
          7.77697 4.11407 7.76955 4.11287 7.76177V4.04946C4.11363 3.47998 4.27873 2.92249 4.58886 2.44216C4.89899 1.96183
          5.34133 1.57851 5.86417 1.33701C6.387 1.09552 6.96873 1.00583 7.54134 1.07844C8.11395 1.15105 8.65377 1.38294
          9.09769 1.74702L9.00175 1.80068L5.77233 3.63947C5.69197 3.68598 5.62524 3.7523 5.57872 3.83193C5.53219 3.91155
          5.50746 4.00175 5.50695 4.09366L5.50378 8.5755ZM6.24563 6.99849L8.00421 5.9987L9.76595 6.99849V8.99807L8.01054
          9.99796L6.24889 8.99807L6.24563 6.99849Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2084_14823">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default OpenAiIcon;
